import { compose, withErrorBoundary } from '../dependencies';

import { withTranslatable } from '../modules/localization';

const Children = ({ children }) => children;

export default compose(withTranslatable, withErrorBoundary)(Children);
